import { routes } from "utils/routes";

/**
 * Routes where to hide cookies modal
 */
export const HIDE_COOKIES_MODAL_ROUTES = [routes.LandingPage, routes.Privacy];
